import React, { useState, useEffect, useContext } from 'react'
import {
  Container, Modal, ModalBody, ModalFooter, Button
} from 'reactstrap'
import { isEmpty } from 'lodash'
import { withRouter } from 'react-router-dom'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'
import ImageGallery from 'react-image-gallery'
import "react-image-gallery/styles/scss/image-gallery.scss"
import '../../assets/css/app.css'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import CategoriesHeadband from '../../components/Common/Headband/CategoriesHeadband'
import BannerGallery from '../../components/Common/Gallerys/Banners/Index'
import AcademyGallery from '../../components/Common/Gallerys/Academy/Index'
import TopProducts from '../../components/Common/Lists/TopProducts'

const Home = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const [categories, setCategories] = useState([])
  const [banners, setBanners] = useState([])
  const [academys, setAcademys] = useState([])
  const [products, setProducts] = useState([])

  const [openWelcomeModal, setOpenWelcomeModal] = useState(false)
  const toggleOpenWelcomeModal = () => setOpenWelcomeModal(!openWelcomeModal)

  useEffect(() => {
    const alreadySignUp = localStorage.getItem("alreadySignUp")
    if (!alreadySignUp) {
      toggleOpenWelcomeModal()
    }
  }, []); // eslint-disable-line

  async function getCategories() {
    try {
      setLoading(true)
      const response = await ApiService.getProductsCategories([])
      setCategories(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getBanners() {
    try {
      setLoading(true)
      const response = await ApiService.getBanners()
      setBanners(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function getAcademy() {
    try {
      setLoading(true)
      const response = await ApiService.getAcademys()
      setAcademys(response.data.data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  async function fetchProducts() {
    try {
      setLoading(true)
      const response = await ApiService.getProductsMostSold()
      const { data } = response.data
      setProducts(data)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    (async function fetch() {
      await getCategories()
      await getBanners()
      await getAcademy()
      await fetchProducts()
    })()
  }, []) // eslint-disable-line

  const images = [
    {
      original: 'https://storage.googleapis.com/vendora-storage/assets/images/onboarding_vendora15-1.png',
      bulletClass: 'gallery-bullets'
    },
    {
      original: 'https://storage.googleapis.com/vendora-storage/assets/images/onboarding_vendora15-2.png',
      bulletClass: 'gallery-bullets'
    },
    {
      original: 'https://storage.googleapis.com/vendora-storage/assets/images/onboarding_vendora15-3.png',
      bulletClass: 'gallery-bullets'
    },
  ]

  const categoryAction = (item) => {
    props.history.push(`/discovery`, { categories: item.id })
  }

  const academyAction = (item) => {
    window.open(item.link, '_blank', 'noopener,noreferrer')
  }

  const productAction = (item) => {
    props.history.push(`/producto/${item.slug}`)
  }

  const toggleWelcomeModal = () => {
    localStorage.setItem("alreadySignUp", true)
    toggleOpenWelcomeModal()
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ backgroundColor: 'white' }}>
        <Container fluid>
          <CategoriesHeadband data={categories} action={categoryAction} />
          <BannerGallery images={banners} />
          <div style={{ marginTop: '20px' }}>
            <AcademyGallery images={academys} action={academyAction} />
          </div>
          <div>
            <TopProducts products={products} goTo={() => props.history.push(`/discovery`)} action={productAction} />
          </div>
          {!isEmpty(products) && (
            <div style={{ textAlign: 'center', padding: '24px' }}>
              <Button
                color="primary"
                style={{
                  textTransform: 'uppercase',
                  padding: `16px 48px`
                }}
                onClick={() => {
                  window.analytics.track(`go to discovery from home`)
                  props.history.push(`/discovery`)
                }}
              >
                Ver todos los productos
              </Button>
            </div>
          )}
        </Container>
      </div>
      <div>
        <Modal isOpen={openWelcomeModal} toggle={toggleOpenWelcomeModal}>
          <ModalBody>
            <ImageGallery
              autoPlay
              showPlayButton={false}
              showFullscreenButton={false}
              items={images}
              slideInterval={8000}
              showNav
              showBullets={true}
              showThumbnails={false}
              onClick={() => {
                window.analytics.track("Welcome Modal Switched Step")
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary" className="btn btn-primary waves-effect waves-light mb-2 mr-2" onClick={toggleWelcomeModal}>Cerrar</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Home)
